<template>
  <div class="menu-manage">
    <!-- Tab标签页 -->
    <el-tabs v-model="activeTab" class="manage-tabs">
      <!-- 角色权限分配Tab -->
      <el-tab-pane label="角色权限分配" name="permission">
        <div class="tab-content">
          <el-row :gutter="24" class="permission-section">
            <!-- 角色列表面板 -->
            <el-col :xs="24" :sm="8" :md="6" :lg="5">
              <div class="panel role-panel">
                <div class="panel-header">
                  <div class="header-left">
                    <i class="el-icon-s-custom header-icon"></i>
                    <span class="panel-title">角色列表</span>
                  </div>
                  <el-tag size="small" type="info">{{ roles.length }} 个角色</el-tag>
                </div>
                <div class="panel-body" v-loading="loadingRoles">
                  <!-- 骨架屏 -->
                  <template v-if="loadingRoles">
                    <div class="skeleton-item" v-for="i in 3" :key="i">
                      <div class="skeleton-avatar"></div>
                      <div class="skeleton-content">
                        <div class="skeleton-title"></div>
                        <div class="skeleton-desc"></div>
                      </div>
                    </div>
                  </template>
                  <!-- 角色列表 -->
                  <div v-else class="role-list">
                    <div v-for="role in roles" :key="role.id"
                      :class="['role-card', { 'is-active': activeRoleId === role.id }]"
                      @click="handleRoleSelect(role.id)">
                      <div class="role-avatar">
                        <i class="el-icon-user-solid"></i>
                      </div>
                      <div class="role-info">
                        <div class="role-name">{{ role.roleName }}</div>
                        <div class="role-desc">{{ role.description || '暂无描述' }}</div>
                      </div>
                      <div class="role-indicator" v-if="activeRoleId === role.id">
                        <i class="el-icon-check"></i>
                      </div>
                    </div>
                    <el-empty v-if="roles.length === 0" description="暂无角色数据" :image-size="80"></el-empty>
                  </div>
                </div>
              </div>
            </el-col>

            <!-- 菜单权限面板 -->
            <el-col :xs="24" :sm="16" :md="18" :lg="19">
              <div class="panel menu-panel">
                <div class="panel-header">
                  <div class="header-left">
                    <i class="el-icon-menu header-icon"></i>
                    <span class="panel-title">菜单权限</span>
                    <el-tag v-if="currentRole" size="small" type="success">
                      {{ currentRole.roleName }}
                    </el-tag>
                  </div>
                  <div class="header-actions" v-if="currentRole">
                    <el-button type="primary" size="small" icon="el-icon-check" @click="confirmSaveRoleMenus"
                      :loading="saving">
                      保存权限
                    </el-button>
                  </div>
                </div>
                <div class="panel-body" v-loading="loadingMenus">
                  <!-- 未选择角色提示 -->
                  <div v-if="!currentRole" class="empty-state">
                    <i class="el-icon-arrow-left empty-icon"></i>
                    <p class="empty-text">请从左侧选择一个角色</p>
                    <p class="empty-hint">选择角色后将显示该角色的菜单权限配置</p>
                  </div>
                  <!-- 菜单权限树 -->
                  <template v-else>
                    <!-- 工具栏 -->
                    <div class="tree-toolbar">
                      <div class="toolbar-left">
                        <el-input v-model="searchKeyword" placeholder="搜索菜单..." prefix-icon="el-icon-search"
                          size="small" clearable style="width: 200px" />
                      </div>
                      <div class="toolbar-right">
                        <el-button-group>
                          <el-button size="mini" icon="el-icon-check" @click="checkAll">全选</el-button>
                          <el-button size="mini" icon="el-icon-close" @click="uncheckAll">清空</el-button>
                        </el-button-group>
                        <el-button-group style="margin-left: 8px">
                          <el-button size="mini" icon="el-icon-arrow-down" @click="expandAll">展开</el-button>
                          <el-button size="mini" icon="el-icon-arrow-up" @click="collapseAll">折叠</el-button>
                        </el-button-group>
                      </div>
                    </div>
                    <!-- 统计信息 -->
                    <div class="tree-stats">
                      <span class="stat-item">
                        <i class="el-icon-folder-opened"></i>
                        共 {{ totalMenuCount }} 个菜单
                      </span>
                      <span class="stat-item">
                        <i class="el-icon-check"></i>
                        已选择 <strong>{{ checkedCount }}</strong> 个
                      </span>
                    </div>
                    <!-- 菜单树 -->
                    <el-tree ref="menuTree" :data="filteredMenuTree" :props="treeProps" show-checkbox node-key="id"
                      :default-expand-all="false" :expand-on-click-node="false" :check-strictly="false"
                      :default-checked-keys="checkedKeys" :filter-node-method="filterNode" class="menu-tree"
                      @check="handleTreeCheck">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span class="node-content">
                          <i :class="['node-icon', data.iconClass || 'el-icon-menu']"></i>
                          <span class="node-title">{{ data.title }}</span>
                          <el-tag v-if="data.pageType !== undefined" :type="getPageTypeTag(data.pageType)" size="mini"
                            effect="plain">
                            {{ getPageTypeName(data.pageType) }}
                          </el-tag>
                          <el-tag v-if="data.isDefault" type="warning" size="mini" effect="plain">首页</el-tag>
                          <el-tag v-if="!data.isEnabled" type="danger" size="mini" effect="plain">禁用</el-tag>
                        </span>
                        <span class="node-path">{{ data.routePath }}</span>
                      </span>
                    </el-tree>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>

      <!-- 菜单管理Tab -->
      <el-tab-pane label="菜单管理" name="manage">
        <div class="tab-content">
          <div class="manage-section">
            <div class="section-toolbar">
              <div class="toolbar-left">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="createMenuInit">
                  新增菜单
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="refreshMenuList">
                  刷新
                </el-button>
              </div>
              <div class="toolbar-right">
                <el-tag size="small" type="info">共 {{ menuList.length }} 个菜单</el-tag>
              </div>
            </div>
            <el-table :data="menuList" row-key="id" border :tree-props="{ children: 'children' }" default-expand-all
              v-loading="loadingMenuList" class="menu-table">
              <el-table-column prop="title" label="菜单标题" min-width="180">
                <template slot-scope="scope">
                  <span class="table-title">
                    <i :class="['title-icon', scope.row.iconClass || 'el-icon-menu']"></i>
                    {{ scope.row.title }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="routePath" label="路由路径" min-width="150">
                <template slot-scope="scope">
                  <el-tag size="small" effect="plain">{{ scope.row.routePath }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
              <el-table-column prop="pageType" label="页面类型" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="getPageTypeTag(scope.row.pageType)" size="small">
                    {{ getPageTypeName(scope.row.pageType) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="isDefault" label="默认首页" width="90" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.isDefault" type="warning" size="small">
                    <i class="el-icon-star-on"></i> 是
                  </el-tag>
                  <span v-else class="text-muted">-</span>
                </template>
              </el-table-column>
              <el-table-column prop="isEnabled" label="状态" width="90" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.isEnabled" @change="handleStatusChange(scope.row)"
                    active-color="#67C23A" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" icon="el-icon-edit" @click="editMenu(scope.row)">
                    编辑
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-delete" style="color: #F56C6C"
                    @click="deleteMenu(scope.row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增/编辑菜单弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false"
      custom-class="menu-dialog" @closed="resetForm">
      <el-form ref="menuForm" :model="menuForm" :rules="menuRules" label-width="100px" class="menu-form">
        <el-form-item label="父菜单">
          <el-cascader v-model="menuForm.parentIdPath" :options="menuTree" :props="cascaderProps" clearable
            placeholder="不选择则为顶级菜单" change-on-select style="width: 100%" />
        </el-form-item>
        <el-form-item label="菜单标题" prop="title">
          <el-input v-model="menuForm.title" placeholder="请输入菜单标题" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="路由路径" prop="routePath">
          <el-input v-model="menuForm.routePath" placeholder="请输入路由路径，如 /users">
            <template slot="prepend">/</template>
          </el-input>
        </el-form-item>
        <el-form-item label="图标类名">
          <el-input v-model="menuForm.iconClass" placeholder="如 el-icon-user-solid">
            <template slot="prepend">
              <i :class="menuForm.iconClass || 'el-icon-menu'"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="排序" prop="sortOrder">
              <el-input-number v-model="menuForm.sortOrder" :min="0" :max="999" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="页面类型" prop="pageType">
              <el-select v-model="menuForm.pageType" style="width: 100%">
                <el-option label="后台页面" :value="0">
                  <i class="el-icon-s-platform"></i> 后台页面
                </el-option>
                <el-option label="前台页面" :value="1">
                  <i class="el-icon-mobile-phone"></i> 前台页面
                </el-option>
                <el-option label="两者兼具" :value="2">
                  <i class="el-icon-s-grid"></i> 两者兼具
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="默认首页">
          <div class="form-switch-row">
            <el-switch v-model="menuForm.isDefault" active-color="#E6A23C" />
            <span class="form-tip">
              <i class="el-icon-info"></i>
              设置后将作为用户登录后的默认首页
            </span>
          </div>
        </el-form-item>
        <el-form-item label="是否启用">
          <div class="form-switch-row">
            <el-switch v-model="menuForm.isEnabled" active-color="#67C23A" />
            <span class="form-tip">
              <i class="el-icon-info"></i>
              禁用后用户将无法看到此菜单
            </span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitMenu">
          {{ menuForm.id ? '保存修改' : '创建菜单' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'

export default {
  name: 'MenuManage',
  data () {
    return {
      // Tab相关
      activeTab: 'permission',

      // 角色相关
      roles: [],
      activeRoleId: '',
      currentRole: null,
      loadingRoles: false,

      // 菜单树相关
      menuTree: [],
      checkedKeys: [],
      treeProps: {
        children: 'children',
        label: 'title'
      },
      saving: false,
      loadingMenus: false,
      searchKeyword: '',
      checkedCount: 0,

      // 菜单管理相关
      menuList: [],
      loadingMenuList: false,

      // 弹窗相关
      dialogVisible: false,
      dialogTitle: '新增菜单',
      submitting: false,
      menuForm: {
        id: null,
        parentId: null,
        parentIdPath: [],
        title: '',
        routePath: '',
        iconClass: '',
        sortOrder: 0,
        pageType: 0,
        isDefault: false,
        isEnabled: true
      },
      menuRules: {
        title: [
          { required: true, message: '请输入菜单标题', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        routePath: [
          { required: true, message: '请输入路由路径', trigger: 'blur' },
          { pattern: /^\/[\w\-/]*$/, message: '路由路径格式不正确', trigger: 'blur' }
        ]
      },
      cascaderProps: {
        value: 'id',
        label: 'title',
        children: 'children',
        checkStrictly: true,
        emitPath: false
      }
    }
  },
  computed: {
    // 过滤后的菜单树
    filteredMenuTree () {
      if (!this.searchKeyword) return this.menuTree
      return this.filterTree(this.menuTree, this.searchKeyword.toLowerCase())
    },
    // 菜单总数
    totalMenuCount () {
      return this.countTreeNodes(this.menuTree)
    }
  },
  watch: {
    searchKeyword (val) {
      if (this.$refs.menuTree) {
        this.$refs.menuTree.filter(val)
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    // 初始化数据
    async initData () {
      this.loadingRoles = true
      this.loadingMenuList = true
      try {
        await Promise.all([
          this.getRoles(),
          this.getMenuTree(),
          this.getMenuList()
        ])
      } finally {
        this.loadingRoles = false
        this.loadingMenuList = false
      }
    },

    // 获取页面类型名称
    getPageTypeName (pageType) {
      const types = { 0: '后台', 1: '前台', 2: '两者' }
      return types[pageType] || '后台'
    },

    // 获取页面类型标签颜色
    getPageTypeTag (pageType) {
      const tags = { 0: 'primary', 1: 'success', 2: 'info' }
      return tags[pageType] || 'primary'
    },

    // 获取角色列表
    async getRoles () {
      try {
        const res = await this.$axios.get(api.getRoles)
        this.roles = res.data.result || []
      } catch (error) {
        console.error('获取角色列表失败:', error)
        this.$message.error('获取角色列表失败，请刷新重试')
      }
    },

    // 获取菜单树
    async getMenuTree () {
      try {
        const res = await this.$axios.get(api.getMenuTree)
        this.menuTree = res.data.result || []
      } catch (error) {
        console.error('获取菜单树失败:', error)
        this.$message.error('获取菜单树失败')
      }
    },

    // 获取菜单列表
    async getMenuList () {
      this.loadingMenuList = true
      try {
        const res = await this.$axios.get(api.getAllMenus)
        this.menuList = this.buildTree(res.data.result || [], null)
      } catch (error) {
        console.error('获取菜单列表失败:', error)
        this.$message.error('获取菜单列表失败')
      } finally {
        this.loadingMenuList = false
      }
    },

    // 刷新菜单列表
    refreshMenuList () {
      this.getMenuTree()
      this.getMenuList()
    },

    // 构建树形结构
    buildTree (list, parentId) {
      const result = []
      const children = list.filter(item => item.parentId === parentId)
      children.forEach(item => {
        const node = { ...item, children: this.buildTree(list, item.id) }
        result.push(node)
      })
      return result
    },

    // 过滤树节点
    filterTree (tree, keyword) {
      const result = []
      for (const node of tree) {
        const matchTitle = node.title.toLowerCase().includes(keyword)
        const matchPath = node.routePath && node.routePath.toLowerCase().includes(keyword)
        const filteredChildren = node.children ? this.filterTree(node.children, keyword) : []

        if (matchTitle || matchPath || filteredChildren.length > 0) {
          result.push({
            ...node,
            children: filteredChildren
          })
        }
      }
      return result
    },

    // 树节点过滤方法
    filterNode (value, data) {
      if (!value) return true
      const keyword = value.toLowerCase()
      return data.title.toLowerCase().includes(keyword) ||
        (data.routePath && data.routePath.toLowerCase().includes(keyword))
    },

    // 统计树节点数量
    countTreeNodes (tree) {
      let count = 0
      for (const node of tree) {
        count++
        if (node.children && node.children.length > 0) {
          count += this.countTreeNodes(node.children)
        }
      }
      return count
    },

    // 选择角色
    async handleRoleSelect (roleId) {
      if (this.activeRoleId === roleId) return

      this.activeRoleId = roleId
      this.currentRole = this.roles.find(r => r.id === roleId)
      this.loadingMenus = true

      try {
        const res = await this.$axios.get(api.getRoleMenus(roleId))
        this.checkedKeys = res.data.result || []
        this.$nextTick(() => {
          if (this.$refs.menuTree) {
            this.$refs.menuTree.setCheckedKeys(this.checkedKeys)
            this.updateCheckedCount()
          }
        })
      } catch (error) {
        console.error('获取角色菜单失败:', error)
        this.$message.error('获取角色菜单权限失败')
      } finally {
        this.loadingMenus = false
      }
    },

    // 树节点选中变化
    handleTreeCheck () {
      this.updateCheckedCount()
    },

    // 更新选中数量
    updateCheckedCount () {
      if (this.$refs.menuTree) {
        const checked = this.$refs.menuTree.getCheckedKeys()
        const halfChecked = this.$refs.menuTree.getHalfCheckedKeys()
        this.checkedCount = checked.length + halfChecked.length
      }
    },

    // 全选
    checkAll () {
      if (this.$refs.menuTree) {
        const allKeys = this.getAllNodeKeys(this.menuTree)
        this.$refs.menuTree.setCheckedKeys(allKeys)
        this.updateCheckedCount()
      }
    },

    // 清空选择
    uncheckAll () {
      if (this.$refs.menuTree) {
        this.$refs.menuTree.setCheckedKeys([])
        this.updateCheckedCount()
      }
    },

    // 获取所有节点key
    getAllNodeKeys (tree) {
      let keys = []
      for (const node of tree) {
        keys.push(node.id)
        if (node.children && node.children.length > 0) {
          keys = keys.concat(this.getAllNodeKeys(node.children))
        }
      }
      return keys
    },

    // 展开所有
    expandAll () {
      this.setTreeExpand(this.menuTree, true)
    },

    // 折叠所有
    collapseAll () {
      this.setTreeExpand(this.menuTree, false)
    },

    // 设置树展开状态
    setTreeExpand (tree, expanded) {
      for (const node of tree) {
        const nodeInstance = this.$refs.menuTree.getNode(node.id)
        if (nodeInstance) {
          nodeInstance.expanded = expanded
        }
        if (node.children && node.children.length > 0) {
          this.setTreeExpand(node.children, expanded)
        }
      }
    },

    // 确认保存权限
    confirmSaveRoleMenus () {
      this.$confirm('确定要保存当前角色的菜单权限配置吗？', '确认保存', {
        confirmButtonText: '确定保存',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.saveRoleMenus()
      }).catch(() => { })
    },

    // 保存角色菜单权限
    async saveRoleMenus () {
      if (!this.currentRole) {
        this.$message.warning('请先选择角色')
        return
      }

      this.saving = true
      try {
        const checkedKeys = this.$refs.menuTree.getCheckedKeys()
        const halfCheckedKeys = this.$refs.menuTree.getHalfCheckedKeys()
        const allKeys = [...checkedKeys, ...halfCheckedKeys]

        await this.$axios.post(api.assignMenus, {
          roleId: this.currentRole.id,
          menuIds: allKeys
        })
        this.$message.success('权限保存成功')
      } catch (error) {
        console.error('保存权限失败:', error)
        this.$message.error('保存权限失败，请重试')
      } finally {
        this.saving = false
      }
    },

    // 新增菜单初始化
    createMenuInit () {
      this.dialogTitle = '新增菜单'
      this.menuForm = {
        id: null,
        parentId: null,
        parentIdPath: [],
        title: '',
        routePath: '',
        iconClass: '',
        sortOrder: 0,
        pageType: 0,
        isDefault: false,
        isEnabled: true
      }
      this.dialogVisible = true
    },

    // 编辑菜单
    editMenu (row) {
      this.dialogTitle = '编辑菜单'
      this.menuForm = {
        id: row.id,
        parentId: row.parentId,
        parentIdPath: row.parentId ? [row.parentId] : [],
        title: row.title,
        routePath: row.routePath,
        iconClass: row.iconClass,
        sortOrder: row.sortOrder,
        pageType: row.pageType || 0,
        isDefault: row.isDefault || false,
        isEnabled: row.isEnabled
      }
      this.dialogVisible = true
    },

    // 删除菜单
    async deleteMenu (row) {
      if (row.children && row.children.length > 0) {
        this.$message.warning('该菜单下有子菜单，请先删除子菜单')
        return
      }

      try {
        await this.$confirm(`确定要删除菜单「${row.title}」吗？`, '删除确认', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        })

        await this.$axios.delete(api.deleteMenu(row.id))
        this.$message.success('删除成功')
        this.refreshMenuList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除菜单失败:', error)
          this.$message.error('删除菜单失败')
        }
      }
    },

    // 状态切换
    async handleStatusChange (row) {
      try {
        await this.$axios.put(api.updateMenu(row.id), {
          title: row.title,
          routePath: row.routePath,
          iconClass: row.iconClass,
          sortOrder: row.sortOrder,
          pageType: row.pageType,
          isDefault: row.isDefault,
          isEnabled: row.isEnabled,
          parentId: row.parentId
        })
        this.$message.success(row.isEnabled ? '已启用' : '已禁用')
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('更新状态失败')
        row.isEnabled = !row.isEnabled // 回滚状态
      }
    },

    // 提交菜单
    async submitMenu () {
      this.$refs.menuForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          // 处理路由路径，确保以/开头
          let routePath = this.menuForm.routePath
          if (!routePath.startsWith('/')) {
            routePath = '/' + routePath
          }

          const data = {
            title: this.menuForm.title,
            routePath: routePath,
            iconClass: this.menuForm.iconClass,
            sortOrder: this.menuForm.sortOrder,
            pageType: this.menuForm.pageType,
            isDefault: this.menuForm.isDefault,
            isEnabled: this.menuForm.isEnabled,
            parentId: this.menuForm.parentIdPath.length > 0
              ? this.menuForm.parentIdPath[this.menuForm.parentIdPath.length - 1]
              : null
          }

          if (this.menuForm.id) {
            await this.$axios.put(api.updateMenu(this.menuForm.id), data)
            this.$message.success('修改成功')
          } else {
            await this.$axios.post(api.createMenu, data)
            this.$message.success('创建成功')
          }

          this.dialogVisible = false
          this.refreshMenuList()
        } catch (error) {
          console.error('保存菜单失败:', error)
          this.$message.error('保存菜单失败')
        } finally {
          this.submitting = false
        }
      })
    },

    // 重置表单
    resetForm () {
      if (this.$refs.menuForm) {
        this.$refs.menuForm.resetFields()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

/* ==================== 基础布局 ==================== */
.menu-manage {
  padding: 20px;
  background: var(--bg-base);
  min-height: calc(100vh - 120px);
}

/* ==================== Tab样式 ==================== */
.manage-tabs {
  margin-bottom: 20px;
  background: var(--bg-white);
  border-radius: 8px;
  box-shadow: var(--shadow-base);
  overflow: hidden;
}

.manage-tabs ::v-deep .el-tabs__header {
  margin: 0;
  background: var(--gradient-header);
  border-bottom: 1px solid var(--border-lighter);
}

.manage-tabs ::v-deep .el-tabs__nav-wrap {
  padding: 0 20px;
}

.manage-tabs ::v-deep .el-tabs__item {
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-regular);
  padding: 0 24px;
}

.manage-tabs ::v-deep .el-tabs__item.is-active {
  color: $primary-color;
  font-weight: 600;
}

.manage-tabs ::v-deep .el-tabs__item:hover {
  color: $primary-color;
}

.manage-tabs ::v-deep .el-tabs__content {
  padding: 0;
}

.tab-content {
  padding: 20px;
}

/* ==================== 面板通用样式 ==================== */
.panel {
  background: var(--bg-white);
  border-radius: 8px;
  border: 1px solid var(--border-lighter);
  overflow: hidden;
  transition: all 0.3s ease;
}

.panel:hover {
  box-shadow: var(--shadow-hover);
}

.panel-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-lighter);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--gradient-header);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-icon {
  font-size: 18px;
  color: $primary-color;
}

.panel-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.panel-body {
  padding: 16px;
  min-height: 400px;
  max-height: 600px;
  overflow-y: auto;
}

/* ==================== 角色列表面板 ==================== */
.role-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.role-card {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  background: var(--bg-hover);
}

.role-card:hover {
  background: rgba(64, 158, 255, 0.08);
  transform: translateX(4px);
}

.role-card.is-active {
  background: rgba(64, 158, 255, 0.1);
  border-color: $primary-color;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.role-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, $primary-color, $primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.role-avatar i {
  font-size: 20px;
  color: #fff;
}

.role-card.is-active .role-avatar {
  background: linear-gradient(135deg, $success-color, $success-light);
}

.role-info {
  flex: 1;
  min-width: 0;
}

.role-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.role-desc {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.role-indicator {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: $success-color;
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-indicator i {
  font-size: 14px;
  color: #fff;
}

/* 骨架屏 */
.skeleton-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
}

.skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(90deg, var(--bg-hover) 25%, var(--border-lighter) 50%, var(--bg-hover) 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  margin-right: 12px;
}

.skeleton-content {
  flex: 1;
}

.skeleton-title {
  height: 16px;
  width: 60%;
  background: linear-gradient(90deg, var(--bg-hover) 25%, var(--border-lighter) 50%, var(--bg-hover) 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-desc {
  height: 12px;
  width: 80%;
  background: linear-gradient(90deg, var(--bg-hover) 25%, var(--border-lighter) 50%, var(--bg-hover) 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/* ==================== 菜单权限面板 ==================== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 48px;
  color: var(--text-placeholder);
  animation: bounce-left 1s ease-in-out infinite;
}

@keyframes bounce-left {

  0%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(-8px);
  }
}

.empty-text {
  font-size: 16px;
  color: var(--text-regular);
  margin: 16px 0 8px;
}

.empty-hint {
  font-size: 14px;
  color: var(--text-secondary);
}

/* 工具栏 */
.tree-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-lighter);
}

.toolbar-right {
  display: flex;
  align-items: center;
}

/* 统计信息 */
.tree-stats {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: var(--bg-hover);
  border-radius: 4px;
}

.stat-item {
  font-size: 13px;
  color: var(--text-regular);
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-item i {
  color: var(--text-secondary);
}

.stat-item strong {
  color: $primary-color;
  font-size: 14px;
}

/* 菜单树 */
.menu-tree {
  background: transparent;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 4px 0;
}

.node-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.node-icon {
  font-size: 16px;
  color: $primary-color;
}

.node-title {
  font-size: 14px;
  color: var(--text-primary);
}

.node-path {
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-hover);
  padding: 2px 8px;
  border-radius: 4px;
}

/* ==================== 菜单管理区域 ==================== */
.manage-section {
  background: var(--bg-white);
  border-radius: 8px;
  border: 1px solid var(--border-lighter);
  padding: 20px;
}

.section-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.toolbar-left {
  display: flex;
  gap: 8px;
}

.menu-table {
  border-radius: 4px;
  overflow: hidden;
}

.table-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  font-size: 16px;
  color: $primary-color;
}

.text-muted {
  color: var(--text-placeholder);
}

/* ==================== 弹窗样式 ==================== */
.menu-form {
  padding: 10px 20px 0;
}

.form-switch-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.form-tip {
  font-size: 12px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.form-tip i {
  font-size: 14px;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 768px) {
  .menu-manage {
    padding: 12px;
  }

  .tab-content {
    padding: 12px;
  }

  .permission-section .el-col {
    margin-bottom: 16px;
  }

  .panel-body {
    min-height: 300px;
    max-height: 400px;
  }

  .tree-toolbar {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .toolbar-left .el-input {
    width: 100% !important;
  }

  .toolbar-right {
    justify-content: space-between;
  }

  .section-toolbar {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}

@media (max-width: 576px) {
  .panel-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .header-actions {
    width: 100%;
  }

  .header-actions .el-button {
    width: 100%;
  }

  .manage-tabs ::v-deep .el-tabs__item {
    padding: 0 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/MenuManage.vue